"use strict";
/*
 * Created on 04 12 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Subset of {@link SelloutSupply} values related to a specific {@link SelloutReleaseItem}
 *
 * @author Jaroslav Sevcik
 */


var SelloutReleaseItemSupply =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemSupply, _DomainObject_1$Domai);

  /**
   * @param id The internal ID.
   * @param releaseItemId The ID of {@link SelloutReleaseItem}.
   * @param date The date to which the sellout supply values relates. Should be a start of day.
   * @param availableSupply The available stock on an internal site (Taken from {@link Supply#availableSupply}).
   * @param amount Specifies the stock amount of inventory in overstock/dead stock/expiration. It is filled only for some sellout types
   *        (e.g. dead stock or (promo) overstock).
   */
  function SelloutReleaseItemSupply(id, releaseItemId, date, availableSupply, amount) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemSupply);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSupply).call(this));
    _this.id = id;
    _this.releaseItemId = releaseItemId;
    _this.date = date;
    _this.availableSupply = availableSupply;
    _this.amount = amount;
    return _this;
  }
  /**
   * @returns The stock amount to be sold out on the site with respect to sellout type ({@link SelloutReleaseItemSupply#amount}
   *          or {@link SelloutReleaseItemSupply#availableSupply})
   */


  _createClass(SelloutReleaseItemSupply, [{
    key: "getStockAmount",
    value: function getStockAmount() {
      return this.amount !== null ? this.amount : this.availableSupply;
    }
  }]);

  return SelloutReleaseItemSupply;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemSupply = SelloutReleaseItemSupply;